import React from "react";
import DataContainer from "components/utility/data-container/DataContainer";
import SearchCallToActionBarContent from "./SearchCallToActionBarContent";

const SearchCallToActionBar = () => (
	<DataContainer data={"searchCallToActionBar"}>
		<SearchCallToActionBarContent />
	</DataContainer>
);

export default SearchCallToActionBar;
